var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Loading } from 'element-ui';
import { Component } from 'vue-property-decorator';
import VueDialog from '../../interface/IVueDialog';
import ApplicationOrderService from '../../api/ApplicationOrderService';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            type_name: '',
            type_code: '',
        };
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = ApplicationOrderService.getInstance();
        if (this.type) {
            this.formData.type_name = this.type.type_name;
            this.formData.type_code = this.type.type_code;
        }
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.submitData = function () {
        var _this = this;
        if (!this.formData.type_name) {
            this.$message.error('请输入类别名称');
            return;
        }
        if (this.type && !this.formData.type_code) {
            this.$message.error('请输入类别编码');
            return;
        }
        var params = __assign({}, this.formData);
        if (this.type)
            params.type_id = this.type.type_id;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service[this.type ? 'updateType' : 'createType'](params)
            .then(function () {
            loadingInstance.close();
            _this.$message.success(_this.type ? '修改成功' : '添加成功');
            _this.close();
            _this.$emit('submit:ok');
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    Dialog = __decorate([
        Component
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
